import React from "react";
import { Link } from "react-router-dom";

export const BrandLogo = () => {
    return (
        <>
            <div
                className="navbar-brand"
                style={{
                    padding: "10px 2px 8px",
                    margin: "0",
                    textAlign: "center",
                }}
            >
                <Link to="/">
                    <img src="https://etouch.s3.ap-south-1.amazonaws.com/primary-image/logo.png" alt="Logo" style={{ width: "26.5%" }}></img>
                </Link>
                {/* <button type='button' className='btn-toggle-offcanvas btn btn-sm float-right'>
                    <i className='lnr lnr-menu icon-close'></i>
                </button> */}
            </div>
        </>
    );
};

export default BrandLogo;
